import * as React from 'react'
import { useEffect } from 'react'
import connect from './connect'
import SelectorWithPopup from '../selector_with_popup'
import CreateProjectTagForm from './create_project_tag_form'

type ProjectTagsSelectorProps = {
  name: string
  value: { value: string; label: string }[]
  options: { value: string; label: string }[]
  canCreateNew: boolean
  buttonTitle: string
  windowTitle: string
  tagType?: string
  formNamePrefix?: string
  windowId?: string
  showDescription?: boolean

  // Redux props
  isFetching: boolean
  availableProjectTags: any[]
  projectTags: any[]
  setAvailableProjectTags: (tags: any[]) => void
  setProjectTags: (tags: any[]) => void
  createNewProjectTag: (data: any) => void
  createProjectTagError: string
  createProjectTagSuccess: string
  resetCreateProjectTagStatusMessages: () => void
}

function ProjectTagsSelector(props: ProjectTagsSelectorProps) {
  const {
    value,
    options,
    name,
    isFetching,
    canCreateNew,
    projectTags,
    setProjectTags,
    setAvailableProjectTags,
    availableProjectTags,
    createNewProjectTag,
    resetCreateProjectTagStatusMessages,
    createProjectTagError,
    createProjectTagSuccess,
    buttonTitle,
    windowTitle,
    tagType = 'Tags::ProjectTag',
    formNamePrefix = 'project_tags',
    windowId = 'create-project-tag',
    showDescription = true,
  } = props

  const [data, setData] = React.useState({
    name: '',
    description: '',
    type: tagType,
  })

  useEffect(() => {
    setData((prevData) => ({
      ...prevData,
      type: tagType,
    }))
  }, [tagType])

  useEffect(() => {
    setAvailableProjectTags(options)
    setProjectTags(value)
  }, [])

  return (
    <SelectorWithPopup
      name={name}
      values={projectTags}
      setValues={setProjectTags}
      options={availableProjectTags}
      canCreateNew={canCreateNew}
      isLoading={isFetching}
      renderForm={(formRef) => (
        <CreateProjectTagForm
          data={data}
          setData={setData}
          formRef={formRef}
          namePrefix={formNamePrefix}
          showDescription={showDescription}
        />
      )}
      onSubmit={() => createNewProjectTag(data)}
      resetStatusMessages={resetCreateProjectTagStatusMessages}
      errorMessage={createProjectTagError}
      successMessage={createProjectTagSuccess}
      buttonTitle={buttonTitle}
      windowTitle={windowTitle}
      windowId={windowId}
    />
  )
}

export default connect(ProjectTagsSelector)
